import { z } from 'zod';
import { ApiSuccessResponseSchema } from './api';

/**
 * Manager Operation Schemas
 * 
 * Epic 2 - Story 2.3: Runtime Type Safety
 * 
 * These schemas validate manager-related operations.
 */

/**
 * Manager chain entry returned by the manager lookup backend.
 */
export const ManagerChainEntrySchema = z.object({
  name: z.string().nullable(),
  email: z.string().email().nullable(),
});

export type ManagerChainEntry = z.infer<typeof ManagerChainEntrySchema>;

/**
 * Manager lookup response.
 */
export const ManagerInfoSchema = z.object({
  manager_chain: z.array(ManagerChainEntrySchema),
});

export type ManagerInfo = z.infer<typeof ManagerInfoSchema>;

/**
 * Get Managers Response
 */
export const GetManagersResponseSchema = ApiSuccessResponseSchema(
  ManagerInfoSchema
);

export type GetManagersResponse = z.infer<typeof GetManagersResponseSchema>;

/**
 * Selected Manager
 * Frontend-internal shape representing a manager selected in the UI.
 */
export interface SelectedManager {
  managerName: string;
  managerEmail: string;
}

